import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const referralVIPRolesRBAC = {
  pageID: '98a3c6eeb8e07e9838d4e40622204767',
  elementID: {
    ViewPage: '0d76a5eca7d44cc930063e2c6139f45d',
    ButtonAdd: 'b9a8ae6c488d224144ac57f94e00ed3c',
    ButtonDelete: '7fe0a373104e71a5bb4e98d0adc7571a',
  },
} as const

export const useRBACReferralVIPPage = createUseRBAC(referralVIPRolesRBAC.elementID)

export type UseRBACReferralVIPPageType = ReturnType<typeof useRBACReferralVIPPage>
